/*
 * 医疗行业
 */
import React from 'react';
import SkeletonNew from 'components/solution/skeletonNew';
import { headBg, headBgM, challenge, frameSrc, frameSrcM, frame, advantage, scene, caseList } from 'constants/solution/med-solution';

const Medical = () => {
  return (
    <SkeletonNew
      headFixed={true}
      challenge={challenge}
      caseList={caseList}
      advantage={advantage}
      scene={scene}
      frame={frame}
      headBg={headBg}
      headBgM={headBgM}
      title="医疗行业解决方案"
      simpleDesc="打破时空限制 远程分级诊疗"
      desc={`小鱼易连通过整合业务系统为远程医疗提供数据及流程支撑，打造全流程、全网络、全\n场景、全贯通、全业务的远程医疗平台，帮助患者实现远程就医，提升基层医生医疗水\n平，提高医疗救治服务效率，推动基层医疗发展，促进分级诊疗，优化医疗资源配置，\n创新互联网医院发展模式，推动区域医疗协同发展。`}
      pageTitle="医疗企业"
      tdkWord="medical"
      frameSrc={frameSrc}
      frameSrcM={frameSrcM}
    />
  );
};

export default Medical;
